import common from './common'
import manage from './manage.js'

export default Object.assign({}, common, manage)



// WEBPACK FOOTER //
// ./src/pages/exchangeDataManage/services/index.js